var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('canvas',{ref:"canvasElement",staticClass:"canvas-drawing-base",on:{"mousedown":_vm.dragStart,"mouseup":_vm.dragEnd,"mouseout":_vm.dragEnd,"mousemove":_vm.dragging,"touchstart":_vm.dragStart,"touchend":_vm.dragEnd,"touchcancel":_vm.dragEnd,"touchmove":_vm.dragging}})
}
var staticRenderFns = []

export { render, staticRenderFns }